import React from 'react';
import { CloseIcon } from '@yme/assets/icons';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { buildKey, noop } from '@yme/common/index';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { RegularTextLevel4 } from '@yme/tokens/typography';
import { FlexWrapperStyled, RegularLinkLevel2Styled } from './styled';
export function ClearAll(props) {
    const { onClick = noop, isRightToLeft = false, label, dataTestId = 'default', iconType = CloseIcon, color = colorCoreBlack900Base, isViewShort = false, } = props;
    const finalDataTestId = buildKey('ClearAll', dataTestId);
    const onClickHandler = (event) => {
        if (event) {
            onClick();
        }
    };
    if (isViewShort) {
        return (React.createElement(RegularLinkLevel2Styled, { as: "button", type: "button", color: color, onClick: onClickHandler }, label));
    }
    return (React.createElement(FlexWrapperStyled, { as: "button", type: "button", onClick: onClickHandler, "data-testid": finalDataTestId, isRightToLeft: isRightToLeft, alignItems: "center", gap: "6px" },
        React.createElement(SVGIcon, { type: iconType, size: ICON_SIZE.s, pathFill: color }),
        React.createElement(RegularTextLevel4, { color: color }, label)));
}
ClearAll.displayName = 'ClearAll_Atom';
